import styled from 'styled-components';

import {
  typography,
} from '../../theme'

export const Wrapper = styled.span`
  ${typography.BODY__SMALL};
  margin: 0.5rem;
  pointer-events: none;
  position: fixed;
  z-index: 9999;
`;



// WEBPACK FOOTER //
// ./src/components/Tooltip/style.js